export function hrtime(time?: [number, number]): [number, number] {
  return process.hrtime(time);
}
